import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  quote: 'Antes solo publicaba contenido en Instagram. Ahora con la página web, los clientes llegan informados y listos para contratar mis servicios.',
  author: 'Carlos Méndez',
  role: 'Consultor de Negocios',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'En la primera semana con la página web + Meta Ads conseguí 12 consultas nuevas. Nunca había llenado mi agenda tan rápido.',
  author: 'Dra. María González',
  role: 'Especialista en Skin Care',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'La inversión se pagó con los primeros 3 clientes. Mi página muestra mis servicios de forma profesional y los clientes confían desde el primer momento.',
  author: 'Lic. Ana Mora',
  role: 'Abogada — Derecho Empresarial',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'Tenía mi negocio solo en Facebook y perdía muchos clientes. Ahora la gente ve mis servicios completos y me escribe directo para agendar.',
  author: 'Dr. Roberto Vargas',
  role: 'Odontólogo — Sonrisa Perfecta',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'El equipo A-Z entendió perfecto mi negocio. La página transmite la confianza y profesionalismo que mis clientes necesitan ver.',
  author: 'Laura Jiménez',
  role: 'Arquitecta de Interiores',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section id="testimonios" className="py-24 bg-[#0a0a1a] relative overflow-hidden" data-id="element-516">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-517">
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-purple-900/10 rounded-full blur-[100px]" data-id="element-518" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-blue-900/10 rounded-full blur-[80px]" data-id="element-519" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-520">
        <div className="text-center mb-16" data-id="element-521">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-522">
            Profesionales Que Ya{' '}
            <span className="text-gradient-cosmic" data-id="element-523">Están Creciendo</span>
          </h2>
        </div>

        <div className="relative bg-[#050510]/50 backdrop-blur-xl border border-white/5 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-524">
          <Quote className="absolute top-8 left-8 w-12 h-12 text-purple-500/20" data-id="element-525" />

          <div className="min-h-[250px] flex items-center justify-center" data-id="element-526">
            <AnimatePresence mode="wait" data-id="element-527">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.4
            }} className="text-center" data-id="element-528">
                <p className="text-xl md:text-3xl font-medium text-white mb-8 leading-relaxed italic" data-id="element-529">
                  "{testimonials[currentIndex].quote}"
                </p>
                <div className="flex flex-col items-center gap-4" data-id="element-530">
                  <div className="w-16 h-16 rounded-full p-1 bg-gradient-to-r from-purple-500 to-pink-500" data-id="element-531">
                    <img src={testimonials[currentIndex].image} alt={testimonials[currentIndex].author} className="w-full h-full rounded-full object-cover border-2 border-[#050510]" data-id="element-532" />
                  </div>
                  <div data-id="element-533">
                    <h4 className="text-lg font-bold text-white font-orbitron" data-id="element-534">
                      {testimonials[currentIndex].author}
                    </h4>
                    <p className="text-purple-400" data-id="element-535">
                      {testimonials[currentIndex].role}
                    </p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Controls */}
          <div className="flex justify-center gap-4 mt-8" data-id="element-536">
            <button onClick={prev} className="p-2 rounded-full bg-white/5 hover:bg-white/10 text-white transition-colors" aria-label="Previous testimonial" data-id="element-537">
              <ChevronLeft className="w-6 h-6" data-id="element-538" />
            </button>
            <div className="flex gap-2 items-center" data-id="element-539">
              {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-purple-500 w-6' : 'bg-gray-600'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-540" />)}
            </div>
            <button onClick={next} className="p-2 rounded-full bg-white/5 hover:bg-white/10 text-white transition-colors" aria-label="Next testimonial" data-id="element-541">
              <ChevronRight className="w-6 h-6" data-id="element-542" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}